export default __webpack_public_path__ + "static/media/grafema_2ndliferesin_09.0cd3a8b4.jpg";